export const RegexEnum = {
    COMPANY: /^[0-1]\d{9}$/,
    DIGITS_ONLY: /^\d*$/,
    PHONE_NUMBER: /^\+?\d{9,20}$/,
    // House number must contain at least one digit (can have letters/spaces but must have a number)
    HOUSE_NUMBER: /\d/,
    // Postal code must contain at least one digit
    POSTAL_CODE: /\d/,
};
